module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "onboard-arrow",
    style: ([{
      right: _vm.right + 'px'
    }, {
      bottom: _vm.bottom + 'px'
    }])
  }, [_c('div', {
    staticClass: "arrow_box no-print animated infinite onboarding_animate"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07adafc2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/onboarding/OnboardArrowVacationDaySelector.vue
// module id = 1745
// module chunks = 1